import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
import ProfileDropdown from '~/containers/profileDropdown/profileDropdown';
import Logo from '~/components/logo/logo';
import Icon from '~/components/icon/icon';
import styles from './header.css';

export class Header extends Component {
  render() {
    const { hideBurger, onBurgerClick } = this.props;
    return (
      <header className={`flex ${styles.container}`}>
        <div className={`flex justify-center items-center ph2 ${styles.sideNav}`}>
          {!hideBurger && (
            <span className="db dn-l">
              <Icon icon="burger" className="pointer stroke-white" onClick={onBurgerClick} />
            </span>
          )}
          <span className="dn db-l">
            <Link to="/">
              <Logo className={`ml2 mr3 self-center ${styles.logo}`} />
            </Link>
          </span>
        </div>
        <nav className="flex-grow-1 flex items-center justify-center">
          <span className="db dn-l">
            <Link to="/">
              <Logo className={`ml2 mr3 self-center ${styles.logo}`} />
            </Link>
          </span>
        </nav>
        <ProfileDropdown />
        <Toast>
          <div className="absolute bg-error pa3 ma3">
            <ToastHeader>Reactstrap</ToastHeader>
            <ToastBody>This is a toast on a secondary background — check it out!</ToastBody>
          </div>
        </Toast>
      </header>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.jsx